import { FC, ReactNode } from 'react';

import { ICONS } from 'shared/presentation/constants';

import * as S from './styles';

interface ISecurityInfoCardProps {
  title: string;
  description: string;
  icon?: ReactNode;
  transparent?: boolean;
}

const IconLock = ICONS.LOCK;

const SecurityInfoCard: FC<ISecurityInfoCardProps> = ({
  title,
  description,
  icon,
  transparent,
}) => {
  return (
    <S.Container transparent={transparent}>
      <S.IconWrapper>{icon || <IconLock />}</S.IconWrapper>

      <S.Content>
        <S.Title>{title}</S.Title>

        <S.Description>{description}</S.Description>
      </S.Content>
    </S.Container>
  );
};

export default SecurityInfoCard;
